import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';

export const Label = styled('label')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  color: '#7e858e',
  fontSize: '14px',
  fontWeight: 500,
  padding: '4px 0px'
}));

export const HistoryList = styled('div')(({ theme }) => ({}));

export const InfoContainer = styled(Stack)(({ theme }) => ({
  background: '#FFFFFF',
  border: '1px solid #E5E7EB',
  padding: '8px 12px',
  borderBottom: '0px',

  '&:first-child': {
    borderRadius: '6px 6px 0px 0px'
  },

  '&:last-child': {
    borderRadius: '0px 0px 6px 6px',
    borderBottom: '1px solid #E5E7EB'
  }
}));
